import React, { Component } from "react";

class CheckBoxSVG extends React.Component {
  render() {
    return (
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 12 12"
      >
        <polygon
          className="svg"
          points="5.3,11 4.2,11 0,5.3 1.1,4.4 4.7,9.4 10.9,1 12,1.8 "
        />
      </svg>
    );
  }
}

export default CheckBoxSVG;



// WEBPACK FOOTER //
// ./src/svg/CheckBoxSVG.jsx